import React from 'react'
import { Col,Button } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalRecollected = (props) => {

    const {modalCollected,handleToggleCollected,dataCollected,saveDetailSamplingsNotCollected} = props;

    return (
      <Dialog
        header="Cancelar muestra"
        visible={modalCollected}
        onHide={handleToggleCollected}
        className="medium-dialog delete-method"
        headerStyle={{
            background: "#dc2626",
            color: "#fff",
            fontWeight: "600",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px"
        }}
        footer={
            <div className="cancel-sample-footer">
                <Button
                    color="light"
                    onClick={handleToggleCollected}
                    className="mr-2"
                >
                    Cancelar
                </Button>

                <Button
                    color="danger"
                    onClick={() =>
                        saveDetailSamplingsNotCollected(
                            dataCollected.folio,
                            dataCollected.id_quoter_type_sample,
                            dataCollected.id_mic_type_sample
                        )
                    }
                >
                    <i className="fa fa-check mr-1"></i>
                    Confirmar
                </Button>
            </div>
        }
    >
        <div className="cancel-sample-content">
{/* 
            <div className="cancel-sample-icon">
                <img
                    alt="warning"
                    src={require("../../../assets/images/price/warningRecollected.svg")}
                />
            </div> */}


            {/* <h5 className="cancel-sample-title">
                ¿Cancelar muestra?
            </h5> */}

              <div className="cancel-sample-badge">
                <i className="fa fa-flask mr-1"></i>
                {dataCollected?.folio ?? "------"}
            </div>

            <p className="cancel-sample-description">
                La muestra seleccionada será marcada como <b>no recolectada</b> y
                ya no será considerada para el reporte final.
            </p>

            <div className="cancel-sample-warning">
                <i className="fa fa-exclamation-triangle mr-2"></i>
                Esta acción no podrá revertirse.
            </div>

        </div>
    </Dialog>
        
       
    )
}